import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1, 1.5),
    minWidth: 160,
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
  },
  key: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  swatch: {
    width: 10,
    height: 10,
    borderRadius: 2,
    flexShrink: 0,
  },
  value: {
    fontVariantNumeric: "tabular-nums",
  },
}));

// Recharts `content` renderer. Values are text-coloured; the swatch carries
// series identity.
const ChartTooltip = ({
  active,
  payload,
  label,
  labelFormatter,
  formatter,
}) => {
  const classes = useStyles();
  if (!active || !payload || payload.length === 0) return null;

  return (
    <Paper className={classes.paper} elevation={4}>
      <Typography variant="subtitle2" gutterBottom>
        {labelFormatter ? labelFormatter(label, payload) : label}
      </Typography>
      {payload.map((entry) => (
        <div className={classes.row} key={entry.dataKey}>
          <span className={classes.key}>
            <span
              className={classes.swatch}
              style={{ background: entry.color || entry.payload.fill }}
            />
            <Typography variant="body2" color="textSecondary">
              {entry.name}
            </Typography>
          </span>
          <Typography variant="body2" className={classes.value}>
            {formatter ? formatter(entry.value, entry) : entry.value}
          </Typography>
        </div>
      ))}
    </Paper>
  );
};

export default ChartTooltip;
